import { FC, useCallback } from 'react';
import useTheme from '@mui/material/styles/useTheme';

import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';

import { useNotification } from 'components/Notifications';
import { useHoverable } from 'lib';

type Props = {
  children: string;
};

const CopyableText: FC<Props> = ({ children }) => {
  const { hovering, ...hoverable } = useHoverable();
  const { palette } = useTheme();
  const { pop } = useNotification();

  const handleCopyClick = useCallback(() => {
    navigator.clipboard.writeText(children);
    pop('Nukopijuota');
  }, [children, pop]);

  return (
    <Box
      sx={{
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        position: 'relative',
        lineHeight: '30px',
        '&:after': {
          content: '""',
          position: 'absolute',
          top: 0,
          right: 0,
          height: '100%',
          width: '40px',
          background:
            palette.mode === 'light'
              ? 'linear-gradient(90deg, rgba(0,0,0,0), #ffffff)'
              : 'linear-gradient(90deg, rgba(0,0,0,0), #1e1e1e)',
        },
      }}
      {...hoverable}>
      {children}
      {hovering && (
        <IconButton
          size="small"
          onClick={handleCopyClick}
          sx={{
            position: 'absolute',
            right: 0,
            zIndex: 10,
          }}>
          <ContentCopyIcon fontSize="small" />
        </IconButton>
      )}
    </Box>
  );
};

export default CopyableText;
